// bootstrap
import Form from 'react-bootstrap/Form';
// others
import Select from 'react-select'

import { queryTenementWFS, getTenementTypeList, lookupSingleTenementId } from './TenementOverlay'
import { CustomDatePicker, formatDate } from '../CustomDateTools';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import Tabs from 'react-bootstrap/esm/Tabs';
import Tab from 'react-bootstrap/Tab';
import axios from 'axios';
import { withAuth } from '../../api/withAuth';
import classNames from 'classnames'

import { useState, useEffect } from "react"
import { useMap } from '@vis.gl/react-maplibre';

const GoldFinderApi = withAuth(axios.create({
    baseURL: process.env.REACT_APP_GOLD_FINDER_API_URL
}))

export function TenementQueryTool({
    tenementFilters,
    setTenementFilters,
    setTenementPopup,
    setShowTenementPopup,
    overlayVisibility,
    setOverlayVisisbility,
    goldfindermap,
    trigger40EWizard }) {

    const [expiringInMulti, setExpiringInMulti] = useState(3);


    const tenementTypes = getTenementTypeList();

    const toggleIncludePendingTenements = () => {
        setTenementFilters({ ...tenementFilters, includePending: !tenementFilters.includePending });
    }

    const toggleIncludeLiveTenements = () => {
        setTenementFilters({ ...tenementFilters, includeLive: !tenementFilters.includeLive });
    }

    const toggleIncludeDeadTenements = () => {
        setTenementFilters({ ...tenementFilters, includeDead: !tenementFilters.includeDead });
    }

    const toggleIncludeSurveyedTenements = () => {
        setTenementFilters({ ...tenementFilters, includeSurveyed: !tenementFilters.includeSurveyed });
    }

    const toggleIncludeUnsurveyedTenements = () => {
        setTenementFilters({ ...tenementFilters, includeUnsurveyed: !tenementFilters.includeUnsurveyed });

    }

    const toggleTenementLabels = () => {
        setOverlayVisisbility({ ...overlayVisibility, tenementLabels: !overlayVisibility.tenementLabels });
    }

    const setSelectedTenementType = (typesIn) => {
        setTenementFilters({ ...tenementFilters, types: typesIn })
    }

    const setGrantDateBeforeAfter = (radioIn) => {
        setTenementFilters({ ...tenementFilters, grantDateBeforeAfter: radioIn.target.id });
    }

    const setTenementStartDate = (dateIn) => {
        setTenementFilters({ ...tenementFilters, startDate: dateIn });
    }

    const setTenementEndDate = (dateIn) => {
        setTenementFilters({ ...tenementFilters, endDate: dateIn });
    };

    const setTenementGrantDate = (dateIn) => {
        setTenementFilters({ ...tenementFilters, grantDate: dateIn });
    };

    const toggleOverridePendingTenementDisplay = () => {
        setTenementFilters({ ...tenementFilters, overridePendingTenementDisplay: !tenementFilters.overridePendingTenementDisplay });
    }

    const toggleIgnoreFirstTermPl = () => {
        setTenementFilters({ ...tenementFilters, ignoreFirstTermPl: !tenementFilters.ignoreFirstTermPl });
    }

    const toggleExpiringSoonEnabled = () => {
        if (tenementFilters.expiringSoonEnabled) {
            setTenementFilters({ ...tenementFilters, endDate: new Date(3001, 0, 1), expiringSoonEnabled: false });
        } else {
            const currentDate = new Date();
            currentDate.setMonth(currentDate.getMonth() + expiringInMulti)
            setTenementFilters({ ...tenementFilters, endDate: currentDate, expiringSoonEnabled: true });

        }

    }

    const setHolderNameLike = (input) => {
        setTenementFilters({ ...tenementFilters, holderNameLike: input });

    }

    const toggleDeadSpls = () => {

        setTenementFilters({
            ...tenementFilters,
            deadSpls: !tenementFilters.deadSpls,
            includeSurveyed: true,
            includeUnsurveyed: true
        });


    };

    const toggleGrantedOnly = () => {
        setTenementFilters({ ...tenementFilters, grantedOnly: !tenementFilters.grantedOnly });
    };

    const SelectCustomStyles = {
        // https://codesandbox.io/p/sandbox/react-select-valuecontainer-with-max-height-17b26?file=%2Fsrc%2FApp.js%3A28%2C5
        valueContainer: (base) => ({
            ...base,
            maxHeight: 200,
            overflowY: "auto"
        })
    };

    function TransformTenId(input) {
        // sample -> M 15/1407, M15/1407
        let TenIdWithSpaceRegex = /[A-Za-z]\s[0-9]+\/[0-9]+/i;
        let TenIdWithNoSpaceRegex = /[A-Za-z][0-9]+\/[0-9]+/i;
        if (TenIdWithSpaceRegex.test(input)) {
            // then we just need to ensure that the first char is upper
            return input.charAt(0).toUpperCase() + input.slice(1);
        } else if (TenIdWithNoSpaceRegex.test(input)) {
            // then we need to add in the space after the first char
            const out = input.charAt(0).toUpperCase() + " " + input.substr(1, input.length);
            return out;
        } else {
            return input
        }
    }


    const LookupTenId = (e) => {
        e.preventDefault()

        const formData = new FormData(e.target);
        const data = Object.fromEntries(formData.entries());

        lookupSingleTenementId(TransformTenId(data.tenid), setTenementPopup, goldfindermap, setShowTenementPopup, trigger40EWizard);
    };

    const [tenementUpdateDate, setTenementUpdateDate] = useState(new Date());

    const DisplayTenementsLastUpdated = () => {
        GoldFinderApi.get("/tenements/last-update").then((result) => {

            setTenementUpdateDate(new Date(Date.parse(result.data[0].import_date_time)));
        }
        );

    }

    const getBtnClasses = (localMonths, targetMonths) => {
        return classNames(
            "btn",
            "btn-outline-primary",
            "btn-sm",
            { 'active': localMonths === targetMonths }

        )
    }

    useEffect(() => {
        DisplayTenementsLastUpdated();
    }, []);

    useEffect(() => {
        if (expiringInMulti !== "Other" && tenementFilters.expiringSoonEnabled) {
            const currentDate = new Date();
            currentDate.setMonth(currentDate.getMonth() + expiringInMulti)
            if (tenementFilters.endDate.getYear() !== currentDate.getYear() ||
                tenementFilters.endDate.getMonth() !== currentDate.getMonth() ||
                tenementFilters.endDate.getDay() !== currentDate.getDay()) {
                setTenementEndDate(currentDate);
            }
        }
    }, [expiringInMulti]);

    function DelayedStringInputField({ setValue, value }) {
        const [query, setQuery] = useState(value);

        useEffect(() => {
            if (query !== value) {

                const timeOutId = setTimeout(() => setValue(query), 1000);
                return () => clearTimeout(timeOutId);
            }
        }, [query]);


        useEffect(() => {
            if (query !== value) {
                setQuery(value);
            }
        }, [value]);

        return (
            <>
                <Form.Control
                    size="sm"
                    type="text"
                    value={query}
                    onChange={event => setQuery(event.target.value)}
                />
            </>
        );
    }

    return (

        <div>
            <Row className="mb-3 justify-content-center" >Tenements Data Set Updated: {formatDate(tenementUpdateDate)} </Row>
            <Row className="mb-3 justify-content-center">
                <Col xs="auto">
                    <Form.Check
                        id='show_tenement_labels'
                        name='show_tenement_labels'
                        label='Show Tenement Labels'
                        checked={overlayVisibility.tenementLabels}
                        onChange={toggleTenementLabels}
                    />
                </Col>
            </Row>
            <Tabs

                className="mb-3">

                <Tab eventKey="simple" title="Simple Query">
                    <Form onSubmit={(e) => LookupTenId(e)} >
                        <Form.Label style={{ fontSize: 12 }} column="sm" >Tenement ID (i.e. P XX/XXXX)</Form.Label>
                        <Row className='mb-3'>
                            <Col>
                                <Form.Control size="sm" name='tenid' type='text' required />

                            </Col>
                            <Col>
                                <button className="btn btn-primary btn-sm" type="submit">Lookup</button>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Check
                                    id='include_pending_tenements'
                                    name='include_pending_tenements'
                                    label='Pending Tenements'
                                    checked={tenementFilters.includePending}
                                    onChange={toggleIncludePendingTenements}
                                />
                                <Form.Check
                                    id='include_live_tenements'
                                    name='include_live_tenements'
                                    label='Live Tenements'
                                    checked={tenementFilters.includeLive}
                                    onChange={toggleIncludeLiveTenements}
                                />
                                <Form.Check
                                    id='include_dead_tenements'
                                    name='include_dead_tenements'
                                    label='Dead Tenements'
                                    checked={tenementFilters.includeDead}
                                    onChange={toggleIncludeDeadTenements}
                                    className='mb-3'
                                />
                            </Col>
                            <Col>
                                <Form.Check
                                    id='include_surveyed_tenements'
                                    name='include_surveyed_tenements'
                                    label='Surveyed Tenements'
                                    checked={tenementFilters.includeSurveyed}
                                    onChange={toggleIncludeSurveyedTenements}

                                />
                                <Form.Check
                                    id='include_unsurveyed_tenements'
                                    name='include_unsurveyed_tenements'
                                    label='Un-Surveyed Tenements'
                                    checked={tenementFilters.includeUnsurveyed}
                                    onChange={toggleIncludeUnsurveyedTenements}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Check
                                    id='include_dead_spls'
                                    name='include_dead_spls'
                                    label='Dead Special Prospecting Licences'
                                    checked={tenementFilters.deadSpls}
                                    onChange={toggleDeadSpls}

                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Check
                                    id='granted_only'
                                    name='granted_only'
                                    label='Granted Only'
                                    checked={tenementFilters.grantedOnly}
                                    onChange={toggleGrantedOnly}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-1">
                            <Col style={{ alignContent: 'center' }}>
                                <Form.Check
                                    id='section19-overlay'
                                    name='section19-overlay'
                                    label='Section 19'
                                    checked={overlayVisibility.section19}
                                    onClick={() => {
                                        setOverlayVisisbility({ ...overlayVisibility, section19: !overlayVisibility.section19 })
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-1">
                            <Col style={{ alignContent: 'center' }}>
                                <Form.Check
                                    id='amalgamations_pending_overlay'
                                    name='amalgamations_pending_overlay'
                                    label='Amalgamations Pending'
                                    checked={overlayVisibility.amalgamationsPending}
                                    onClick={() => {
                                        setOverlayVisisbility({ ...overlayVisibility, amalgamationsPending: !overlayVisibility.amalgamationsPending })
                                    }}
                                />
                            </Col>
                        </Row>
                    </Form>
                </Tab>
                <Tab eventKey="complex" title="Advanced Query">
                    <Form  >
                        <Row className='mb-3'>
                            <Col>
                                <Form.Label column="sm" style={{ marginRight: 10, fontSize: 12 }} >Start Date (After): </Form.Label>
                            </Col>
                            <Col>
                                <CustomDatePicker
                                    date={tenementFilters.startDate}
                                    setDate={(d) => setTenementStartDate(d)}
                                />
                            </Col>
                        </Row>

                        <Row className='mb-3'>
                            <Col>
                                <Form.Label style={{ marginRight: 10, fontSize: 12 }} column="sm" >End Date (Before): </Form.Label>
                                <Form.Check
                                    id='include_unset_end_dates'
                                    name='include_unset_end_dates'
                                    label='Include Un-Set/Invalid End Dates'
                                    disabled
                                />
                            </Col>
                            <Col>
                                <CustomDatePicker
                                    date={tenementFilters.endDate}
                                    setDate={(d) => setTenementEndDate(d)}
                                />
                            </Col>
                        </Row>

                        <Row className='mb-3'>
                            <Col>
                                <Form.Label style={{ marginRight: 10, fontSize: 12 }} column="sm" >Grant Date: </Form.Label>
                                <Form.Check
                                    type='radio'
                                    id='BEFORE'
                                    name='BEFORE-AFTER'
                                    label='Before'
                                    checked={tenementFilters.grantDateBeforeAfter == 'BEFORE'}
                                    onChange={setGrantDateBeforeAfter}
                                />
                                <Form.Check
                                    type='radio'
                                    id='AFTER'
                                    name='BEFORE-AFTER'
                                    label='After'
                                    checked={tenementFilters.grantDateBeforeAfter == 'AFTER'}
                                    onChange={setGrantDateBeforeAfter}
                                />
                                <Form.Check
                                    id='include_unset_end_dates'
                                    name='include_unset_end_dates'
                                    label='Include Un-Set/Invalid End Dates'
                                    disabled
                                />
                            </Col>
                            <Col>

                                <CustomDatePicker
                                    date={tenementFilters.grantDate}
                                    setDate={setTenementGrantDate}
                                />
                            </Col>
                        </Row>
                        <Row className='mb-3'>
                            <Col>
                                <Form.Label style={{ fontSize: 12 }} column="sm" >Tenement Holder (Full or key word)</Form.Label>
                            </Col>
                            <Col>
                                <DelayedStringInputField
                                    value={tenementFilters.holderNameLike}
                                    setValue={val => setHolderNameLike(val)}
                                />
                            </Col>
                        </Row>
                        <Form.Group className='mb-3' >
                            <Form.Label column="sm" >Type</Form.Label>

                            <Select isMulti='true'
                                defaultValue={tenementFilters.types}
                                onChange={setSelectedTenementType}
                                options={tenementTypes}
                                styles={SelectCustomStyles}
                                required  >
                            </Select >
                        </Form.Group>


                    </Form>
                </Tab>
                <Tab eventKey="exsoon" title="Expiring Soon" >
                    <Row className="mb-3 justify-content-center" >
                        <Col className='justify-content-center'>
                            <Form.Check
                                id='expiring_soon_enabled'
                                name='expiring_soon_enabled'
                                label='Enable'
                                checked={tenementFilters.expiringSoonEnabled}
                                onChange={() => toggleExpiringSoonEnabled()}
                                enabled
                            />
                        </Col>
                    </Row>

                    <Row className='mb-3'>
                        <Col>
                            <Form.Label style={{ marginRight: 10, fontSize: 12 }} column="sm" >Expiring in (Months): </Form.Label>
                        </Col>
                        <Col>
                            <div class="btn-group mb-1" en role="group" aria-label="Basic example">
                                <button type="button"
                                    disabled={!tenementFilters.expiringSoonEnabled}
                                    onClick={() => setExpiringInMulti(1)}
                                    className={getBtnClasses(1, expiringInMulti)} >
                                    1
                                </button>

                                <button type="button"
                                    disabled={!tenementFilters.expiringSoonEnabled}
                                    onClick={() => setExpiringInMulti(2)}
                                    className={getBtnClasses(2, expiringInMulti)}>
                                    2
                                </button>

                                <button type="button"
                                    disabled={!tenementFilters.expiringSoonEnabled}
                                    onClick={() => setExpiringInMulti(3)}

                                    className={getBtnClasses(3, expiringInMulti)}>
                                    3
                                </button>

                                <button type="button"
                                    disabled={!tenementFilters.expiringSoonEnabled}
                                    onClick={() => setExpiringInMulti(6)}

                                    className={getBtnClasses(6, expiringInMulti)}>
                                    6
                                </button>

                                <button type="button"
                                    disabled={!tenementFilters.expiringSoonEnabled}
                                    onClick={() => setExpiringInMulti(12)}

                                    className={getBtnClasses(12, expiringInMulti)}>
                                    12
                                </button>

                                <button type="button"
                                    disabled={!tenementFilters.expiringSoonEnabled}
                                    onClick={() => setExpiringInMulti("Other")}

                                    className={getBtnClasses("Other", expiringInMulti)}>
                                    Other
                                </button>

                            </div>
                            <CustomDatePicker
                                date={tenementFilters.endDate}
                                setDate={(d) => setTenementEndDate(d)}
                                isDisabled={!(expiringInMulti === "Other")}
                            />
                        </Col>

                    </Row>
                    <Row className='mb-3'>
                        <Col>
                            <Form.Check
                                id='override_pending_display'
                                name='override_pending_display'
                                label='Show Pending Tenements (that intersect/overlap expiring)'
                                checked={tenementFilters.overridePendingTenementDisplay}
                                onChange={toggleOverridePendingTenementDisplay}
                                disabled={!tenementFilters.expiringSoonEnabled}
                                enabled
                            />
                        </Col>
                    </Row>
                    <Row className='mb-2'>
                        <Col>
                            <Form.Check
                                id='ignore_pl_first_4'
                                name='ignore_pl_first_4'
                                label='Ignore Prospecting Licences in first term'
                                checked={tenementFilters.ignoreFirstTermPl}
                                onChange={toggleIgnoreFirstTermPl}
                                disabled={!tenementFilters.expiringSoonEnabled}
                                enabled
                            />
                        </Col>

                    </Row>
                    <Form.Group className='mb-3' >
                        <Form.Label column="sm" >Type</Form.Label>

                        <Select isMulti='true'
                            defaultValue={tenementFilters.types}
                            onChange={setSelectedTenementType}
                            options={tenementTypes}
                            styles={SelectCustomStyles}
                            isDisabled={!tenementFilters.expiringSoonEnabled}
                            required
                        >
                        </Select >
                    </Form.Group>
                </Tab>

            </Tabs>



        </div >


    )
}

